export enum RecipeTable {
    Recipe = 0,
    CustomerRecipe = 1
}